import { IPolygonData } from '@leafer-ui/interface'

import { UIData } from "./UIData"


export class PolygonData extends UIData implements IPolygonData {

}